import { theme as antdTheme } from "antd";
import { theme as flowbiteDefaultTheme } from "flowbite-react";

// `dark:` variants that only swap neutral colors. Neutrals are theme-aware CSS variables
// (src/index.css), so these would flip a second time in dark mode; drop them.
const NEUTRAL_DARK_VARIANT =
    /(^|\s)dark:(?:[\w-]+:)*(?:bg|text|border|divide|ring|ring-offset|placeholder|from|via|to)-(?:white|gray-\d+|slate-\d+)(?:\/[\w.[\]]+)?(?=\s|$)/g;

const stripNeutralDark = (node) => {
    if (typeof node === "string") return node.replace(NEUTRAL_DARK_VARIANT, "$1").replace(/\s{2,}/g, " ").trim();
    if (node && typeof node === "object") {
        return Object.fromEntries(Object.entries(node).map(([key, value]) => [key, stripNeutralDark(value)]));
    }
    return node;
};

export const flowbiteTheme = stripNeutralDark(flowbiteDefaultTheme);

const FONT = '"Plus Jakarta Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif';

// antd follows the same tokens: black/white primary, neutral-gray dark surfaces.
export const antdThemeConfig = (isDark) => ({
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
        fontFamily: FONT,
        borderRadius: 12,
        colorPrimary: isDark ? "#ffffff" : "#000000",
        colorLink: isDark ? "#ffffff" : "#000000",
        ...(isDark && {
            colorBgBase: "#212121",
            colorBgContainer: "#262626",
            colorBgElevated: "#262626",
            colorBgLayout: "#212121",
            colorBorder: "#3e3e3e",
            colorBorderSecondary: "#3e3e3e",
            colorTextBase: "#f0f0f0",
            // Text, checkmarks and switch knobs drawn on the (white) primary fill.
            colorWhite: "#111827",
            colorTextLightSolid: "#111827",
        }),
    },
    components: {
        Button: { primaryShadow: "none" },
        Modal: { borderRadiusLG: 16 },
    },
});
